import React from 'react';

const BuildRelationshipsGraphic = ({ className }) => (
  <svg className={className} width="475" height="242" viewBox="0 0 475 242" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M197.328 108.017L223.776 134.492" stroke="white" strokeWidth="3" strokeMiterlimit="10" />
    <path
      d="M184.107 108.017C191.41 108.017 197.331 102.09 197.331 94.7787C197.331 87.4676 191.41 81.5408 184.107 81.5408C176.803 81.5408 170.883 87.4676 170.883 94.7787C170.883 102.09 176.803 108.017 184.107 108.017Z"
      stroke="#0D2D29"
      strokeWidth="3"
      strokeMiterlimit="10"
    />
    <path
      d="M237.005 160.968C244.309 160.968 250.229 155.041 250.229 147.73C250.229 140.419 244.309 134.492 237.005 134.492C229.702 134.492 223.781 140.419 223.781 147.73C223.781 155.041 229.702 160.968 237.005 160.968Z"
      stroke="#0D2D29"
      strokeWidth="3"
      strokeMiterlimit="10"
    />
    <path
      d="M289.896 28.589C297.199 28.589 303.12 22.6622 303.12 15.3512C303.12 8.04008 297.199 2.11328 289.896 2.11328C282.592 2.11328 276.672 8.04008 276.672 15.3512C276.672 22.6622 282.592 28.589 289.896 28.589Z"
      stroke="#0D2D29"
      strokeWidth="3"
      strokeMiterlimit="10"
    />
    <path
      d="M289.896 108.017C297.199 108.017 303.12 102.09 303.12 94.7787C303.12 87.4676 297.199 81.5408 289.896 81.5408C282.592 81.5408 276.672 87.4676 276.672 94.7787C276.672 102.09 282.592 108.017 289.896 108.017Z"
      stroke="#0D2D29"
      strokeWidth="3"
      strokeMiterlimit="10"
    />
    <path d="M210.555 94.7786H263.451" stroke="white" strokeWidth="3" strokeMiterlimit="10" />
    <path
      d="M78.3177 108.016C85.6211 108.016 91.5417 102.089 91.5417 94.7784C91.5417 87.4673 85.6211 81.5405 78.3177 81.5405C71.0143 81.5405 65.0938 87.4673 65.0938 94.7784C65.0938 102.089 71.0143 108.016 78.3177 108.016Z"
      stroke="#0D2D29"
      strokeWidth="3"
      strokeMiterlimit="10"
    />
    <path d="M104.766 94.7783H157.662" stroke="white" strokeWidth="3" strokeMiterlimit="10" />
    <path d="M0 94.7786H52.8959" stroke="url(#paint0_linear_301_6)" strokeWidth="3" strokeMiterlimit="10" />
    <path d="M474.328 15.4797L421.432 15.4797" stroke="url(#paint1_linear_301_6)" strokeWidth="3" strokeMiterlimit="10" />
    <path
      d="M395.693 28.589C402.996 28.589 408.917 22.6622 408.917 15.3512C408.917 8.04008 402.996 2.11328 395.693 2.11328C388.389 2.11328 382.469 8.04008 382.469 15.3512C382.469 22.6622 388.389 28.589 395.693 28.589Z"
      stroke="#0D2D29"
      strokeWidth="3"
      strokeMiterlimit="10"
    />
    <path d="M316.344 15.3511H369.24" stroke="white" strokeWidth="3" strokeMiterlimit="10" />
    <path d="M289.898 41.8269V68.3027" stroke="white" strokeWidth="3" strokeMiterlimit="10" />
    <path
      d="M237.005 240.395C244.309 240.395 250.229 234.468 250.229 227.157C250.229 219.846 244.309 213.919 237.005 213.919C229.702 213.919 223.781 219.846 223.781 227.157C223.781 234.468 229.702 240.395 237.005 240.395Z"
      stroke="#0D2D29"
      strokeWidth="3"
      strokeMiterlimit="10"
    />
    <path d="M237.008 174.206V200.681" stroke="white" strokeWidth="3" strokeMiterlimit="10" />
    <defs>
      <linearGradient
        id="paint0_linear_301_6"
        x1="52.5749"
        y1="94.8555"
        x2="-5.07298e-08"
        y2="94.8555"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient id="paint1_linear_301_6" x1="421.753" y1="15.4028" x2="474.328" y2="15.4028" gradientUnits="userSpaceOnUse">
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export default BuildRelationshipsGraphic;
